export const dateTimeFormat = {
  API_DATE_FORMAT: "YYYY-MM-DD",
  GENERAL_DATE_FORMAT: "DD MMM YYYY",
  TIME_FORMAT: "hh:mm A",
  API_DATE_TIME_FORMAT: "YYYY-MM-DD hh:mm A",
};
